import React from 'react'
import { Event } from '@/payload-types'
import { RichText } from '@payloadcms/richtext-lexical/react'

interface EventDetailProps {
  event: Event
}

function EventDetail({ event }: Readonly<EventDetailProps>) {
  const startDate = new Date(event.startDate)
  return (
    <article className="grid grid-cols-1 lg:grid-cols-2 max-w-7xl mx-auto p-4">
      <div>
        {event.content && <RichText data={event.content} className="prose prose-neutral" />}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <time className="border rounded-lg p-4">{startDate.toLocaleDateString()}</time>
        <address className="border rounded-lg p-4 whitespace-pre not-italic">{event.venue}</address>
      </div>
    </article>
  )
}

export { EventDetail }
